import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzUploadChangeParam, NzUploadComponent, NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';


import { BehaviorSubject, combineLatest, Observable, Observer } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { areArrayEqual } from '../../../common';
// import * as download from 'downloadjs';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { toUploadFileList } from '../../to-upload-file-list';
import { resolveFileUrl } from 'mm-web-core/attachment/resolve-url';
import { mmAttachmentConstants } from 'mm-web-core/attachment/attachment-constants';
import { MmHttpClient } from 'mm-web-core/http';
import { NzUploadType } from 'ng-zorro-antd/upload/interface';


@Component({
    selector: 'mm-attachment-input',
    templateUrl: './attachment-input.component.html',
    styleUrls: ['./attachment-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AttachmentInputComponent),
            multi: true
        }
    ]
})
export class AttachmentInputComponent implements OnInit, ControlValueAccessor {


    attachmentSize: number;
    multiple$ = new BehaviorSubject<boolean>(false);
    limit$ = new BehaviorSubject<number>(0);
    disabled$ = new BehaviorSubject<boolean>(false);
    // category$ = new ReplaySubject<AttachmentCategory>(1);
    acceptImage$ = new BehaviorSubject<boolean>(false);
    acceptVideo$ = new BehaviorSubject<boolean>(false);
    acceptDoc$ = new BehaviorSubject<boolean>(false);
    acceptExcel$ = new BehaviorSubject<boolean>(false);
    type$ = new BehaviorSubject<NzUploadType>(undefined);
    files$ = new BehaviorSubject<NzUploadFile[]>([]);
    fileNames$ = this.files$.pipe(
        map(files => files.map(f => f.name))
    );
    @Input() fileDownloadName: string;
    @Input() maxSize: number = 0; //unit: MB
    @Input() tempfile: boolean;
    @Output() fileChange: EventEmitter<any> = new EventEmitter<any>();
    _writedValue: any;
    uploadUrl = resolveFileUrl();
    canUpload$ = combineLatest(
        [this.files$,
        this.multiple$,
        this.limit$,
        this.disabled$]
    ).pipe(
        map(([files, multiple, limit, disabled]) => {
            if (disabled) {
                return false;
            }
            if (!multiple && files.length >= 1) {
                return false;
            }
            if (limit > 0 && files.length >= limit) {
                return false;
            }
            return true;
        }),
        distinctUntilChanged()
    );
    nzShowUploadList$ = this.disabled$.pipe(
        map(disabled => {
            return { showPreviewIcon: disabled, showRemoveIcon: !disabled, showDownloadIcon: false };
        })
    );
    accepts: string[] = [];
    accept$ = combineLatest(
        [this.acceptImage$,
        this.acceptVideo$,
        this.acceptDoc$,
        this.acceptExcel$
        ]
    ).pipe(
        map(([acceptImage, acceptVideo, acceptDoc, acceptExcel]) => {

            if (acceptImage) {
                this.accepts.push('.png');
                this.accepts.push('.jpg');
                this.accepts.push('.jpeg');
            }
            if (acceptVideo) {
                this.accepts.push('.mp4');
            }
            if (acceptDoc) {
                this.accepts.push('.doc');
                this.accepts.push('.docx');
                this.accepts.push('.xls');
                this.accepts.push('.xlsx');
                this.accepts.push('.pdf');

            }
            if (acceptExcel) {
                this.accepts.push('.xls');
                this.accepts.push('.xlsx');
            }
            return this.accepts.join(',');

        })
    );
    listType$ = this.type$.pipe(map(type => {
        if (type === 'drag') {
            return 'text';
        } else {
            return 'picture-card';
        }
    }));
    @ViewChild(NzUploadComponent, { static: true })
    uploader: NzUploadComponent;
    onChange: (_: any) => void;
    onTouched: () => void;
    private previewImage: any;
    private previewVisible: boolean;

    constructor(
        private messageService: NzMessageService,
        private httpClient: HttpClient,
        private translate: TranslateService,
        private mmHttpClient: MmHttpClient
    ) {

    }

    get multiple() {
        return this.multiple$.value;
    }


    @Input()
    set multiple(_: boolean) {
        this.multiple$.next(_);
    }

    @Input()
    set size(size: number) {
        this.attachmentSize = size;
    }

    @Input()
    set type(_: NzUploadType) {
        this.type$.next(_);
    }

    // uploadUrl$ = this.category$.pipe(
    //   map(catgory => uploadUrl(catgory))
    // )

    @Input()
    set acceptImage(_: boolean) {
        this.acceptImage$.next(_);

    }

    @Input()
    set acceptVideo(_: boolean) {
        this.acceptVideo$.next(_);
    }

    @Input()
    set acceptDoc(_: boolean) {
        this.acceptDoc$.next(_);
    }

    @Input()
    set acceptExcel(_: boolean) {
        this.acceptExcel$.next(_);
    }

    get limit() {
        return this.limit$.value;
    }

    @Input()
    set limit(_: number) {
        this.limit$.next(_);
    }

    @Input()
    set fileNames(_: string[]) {

        this.writeValue(_);

    }

    @Input()
    set disabled(_: boolean) {
        this.setDisabledState(_);
    }

    previewFile = (file: NzUploadFile) => {
        return file.thumbUrl;
    };


    ngOnInit(): void {
        this.fileNames$.pipe(
            distinctUntilChanged((x, y) => areArrayEqual(x, y)),
            tap(fileNames => {
                if ((fileNames || []).length == 0) {
                    this.uploader.nzFileList = undefined;
                }

            }),

            switchMap(fileNames => this.multiple$.pipe(map(multiple => {
                return {
                    fileNames,
                    multiple
                };
            }))),
            filter(x => {
                let notifyChanged = false;
                if (x.multiple) {
                    notifyChanged = !areArrayEqual(x.fileNames, this._writedValue);
                } else {
                    notifyChanged = x.fileNames[0] != this._writedValue;
                }
                return notifyChanged;

            }),
        ).subscribe(x => {
            if (this.onChange) {

                if (x.multiple) {
                    this.onChange(x.fileNames);
                } else {
                    this.onChange(x.fileNames[0]);
                }

            }
        });

    }

    isImage = _ => true;


    writeValue(obj: any): void {
        this._writedValue = obj;
        if (obj == undefined) {
            this.files$.next([]);

        } else if (typeof obj === 'string') {
            this.files$.next(toUploadFileList([obj]));
        } else if (Array.isArray(obj)) {
            this.files$.next(toUploadFileList(obj));
        }

    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {

        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled$.next(isDisabled);

    }


    download = (file: NzUploadFile) => {
        const url = `api/_files/${file.originalFileName}?tempfile=${this.tempfile}`;
        this.httpClient.get(url, { responseType: 'arraybuffer' }).subscribe(data => {
            let fileName = file.name;
            if (this.fileDownloadName != undefined) {
                const nameArray = file.name.split('.');
                fileName = `${this.fileDownloadName}.${nameArray[nameArray.length - 1]}`;
            }
            this.downloadFile(data, fileName);
        });
    };

    downloadFile(data, fileName) {
        const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    // files: UploadFile[];

    uploadChange(e: NzUploadChangeParam) {
        if (e.file.status == 'done') {
            e.fileList.filter(f => f.uid == e.file.uid).forEach(f => {
                Object.assign(f, e.file.response);
            });
            this.files$.next(e.fileList);
        } else if (e.file.status === 'error') {
            this.messageService.error(`${e.file.name} file upload failed.`);
        }
    }

    fileListChange(files: NzUploadFile[]) {
        this.files$.next(files || []);
        this.fileChange.emit(files);
    }

    fileListRemove = (file): boolean => {
        return true;
    };

    resolveKey(key: string) {
        return `${mmAttachmentConstants.translationGroup}.${key}`;
    }

    beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
        new Observable((observer: Observer<boolean>) => {
            // 上传文件的后缀进行判断
            file.name.lastIndexOf('.');
            const fileType = file.name.substring(file.name.lastIndexOf('.'), file.name.length);  // 从后往前截取文类型
            const isType = this.accepts.includes(fileType);
            if (!isType) {
                const typeError = this.accepts.join('/');
                this.messageService.error(this.translate.instant('Common.UploadGroup.FileTypeError') + typeError);
                observer.complete();
                return;
            }

            const isSize = this.maxSize == 0 || file.size! / 1024 / 1024 < this.maxSize;
            if (!isSize) {
                this.messageService.error(this.translate.instant('Common.UploadGroup.FileSize') + `${this.maxSize}MB!`);
                observer.complete();
                return;
            }

            observer.next(isType && isSize);
            observer.complete();
        });
    handlePreview = async (file: NzUploadFile): Promise<void> => {
        const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj!);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
    };
}
